import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import lookupService from 'nallian-shared-ui/lib/hoc/lookupService';
import apiRoutes from '../../../app/api/routes';

const Language = ({ value, languagesFetch }) => {
  const language = useMemo(
    () => (languagesFetch.value || []).find(l => l.id === value)?.nativeName,
    [value, languagesFetch.value]
  );

  return <span>{language}</span>;
};

Language.propTypes = {
  languagesFetch: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
};

export default lookupService({ resource: 'languages', url: apiRoutes.getLanguages() })(Language);
